import styled from "@emotion/styled";

import { Container as FloatAreaClickContainer } from "~/components/story-style/story-style-float-clickable-area/styles";

import Cross from "./cross.svg";
import IconLogo from "./logo.svg";

type ContainerProps = {
  $isHidden: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: absolute;
  inset-block-start: 0;

  display: ${props => (props.$isHidden ? "none" : "flex")};
  justify-content: center;

  block-size: 100%;
`;

type CardInfoContainerProps = {
  $hasBottomBannerAd: boolean;
};

export const CardInfoContainer = styled.div<CardInfoContainerProps>`
  position: fixed;
  inset-block-end: ${props => (props.$hasBottomBannerAd ? "calc(100px + 77px + 16px)" : "77px")};
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  inline-size: 100%;
  padding-inline: 32px;

  color: #ffffff;

  ${FloatAreaClickContainer} {
    inset-block-end: -16px;
    inset-inline-end: 0;
    z-index: 2;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
    inset-block-end: ${props => (props.$hasBottomBannerAd ? "calc(100px + 85px + 16px)" : "85px")};
  }
`;

export const StyledCoverLogo = styled(IconLogo)`
  position: absolute;
  inset-block-start: 0;
  z-index: 1;

  inline-size: 100%;
  inline-size: 160px;
  block-size: 101.27px;
  margin-block-start: 48px;

  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.4));
`;

export const StyledCrossButton = styled.a`
  position: absolute;
  inset-block-start: 24px;
  inset-inline-end: 15px;
  z-index: 3;
`;

export const StyledCrossLogo = styled(Cross)`
  inline-size: 18px;
  block-size: 18px;
`;
